import React from "react";
import { Popup } from "@emisgroup/ui-popup";
import { Button } from "@emisgroup/ui-button";
import InfoNotification from "~icons/ic/baseline-info";

interface RelativeDatePopupProps {
  className: string;
}

export const RelativeDatePopup: React.FC<RelativeDatePopupProps> = ({ className }) => {
  return (
    <Popup>
      <Popup.Trigger>
        <Button borderless={true} variant="mono" className={className}>
          <InfoNotification title={""}/>
        </Button>
      </Popup.Trigger>
      <Popup.Content>
        <div style={{ padding: "0.5rem 1rem" }}>
          <div><b>Relative Date</b></div>
          <div>Sets a reference point for filtering data. For example,</div>
          <div>if a process runs on the 5th but should include data</div>
          <div>up to the end of the previous month, set the relative</div>
          <div>run date to the 1st of the current month.</div>
        </div>
      </Popup.Content>
    </Popup>

  );
};
